<template>
    <b-col class="my-2" md="6">
        <div class="purchase_part">
            <div class="organization_part-header">
                <b-row class="w-100 m-0">
                    <b-col class="px-1" lg="8" md="8">
                        <p class="organization_part-header_number">
                            <b-badge v-if="organization.is_smp" v-b-tooltip.hover="{ variant: 'custom-green' }" class="fs-12 mr-2" title="Является субъектом малого предпринимательства" variant="inverse-green">СМП </b-badge>
                            <b-badge v-if="organization.is_isp" v-b-tooltip.hover="{ variant: 'custom-green' }" class="fs-12" title="Является прямым производителем товаров, исполнителем услуг или подрядчиком работ" variant="inverse-green"> ИСП </b-badge>
                        </p>
                    </b-col>
                    <b-col class="px-1" lg="4" md="4">
                        <p v-if="organization.is_registered" class="organization_part-header_label float-right text-right my-auto">
                            <img alt="check_label" class="mr-1" src="/images/check.svg" />
                            Зарегистрирован
                        </p>
                    </b-col>
                </b-row>
            </div>
            <div class="organization_part-body row">
                <div class="px-3 mt-2 w-100">
                    <p class="green-color fw-600 fs-14 text-uppercase">
                        <router-link :to="{ name: 'OrganizationShow', params: { id: organization.id } }" class="system_link-style" target="_blank">{{ organization.name }} </router-link>
                    </p>
                </div>
                <div v-if="organization.address" class="px-3 mb-1 w-100">
                    <p class="fs-14 fw-400 grey-color">
                        Адрес: <span class="fw-600 grey-color"> {{ organization.address }} </span>
                    </p>
                </div>

                <b-col class="organization_part-body_col">
                    <div class="my-2">
                        <div v-if="organization.contact_name" class="w-100 my-2">
                            <p class="m-0 fs-14 grey-color">Контактное лицо:</p>
                            <p class="m-0 fs-14 grey-color fw-600">{{ organization.contact_name }}</p>
                        </div>
                        <div v-if="organization.rating" class="w-100 my-2">
                            <b-row>
                                <b-col>
                                    <p class="fs-14 fw-400 m-0 grey-color">
                                        Рейтинг поставщика:
                                        <span class="fw-600 grey-color"> {{ $formatPrice(organization.rating) }} </span>
                                    </p>
                                </b-col>
                                <b-col md="auto">
                                    <div class="rating_scale float-right">
                                        <div v-for="(el, index) in organizationRatingWhole" :key="'index_' + index" :style="`border-color: ${ratingColor}`" class="rating_scale-part_wrapper">
                                            <div :style="`background-color: ${ratingColor}`" class="rating_scale-part"></div>
                                        </div>
                                        <div v-for="(el, index) in Math.ceil(organizationRatingRest)" :key="'indexx_' + index" class="rating_scale-part_wrapper">
                                            <div :style="`background: linear-gradient(to right, ${ratingColor} 0%, ${ratingColor} ${transitionPercent}%, #fff ${transitionPercent}%, #fff 100%)`" class="rating_scale-part"></div>
                                        </div>
                                        <div v-for="(el, index) in rest" :key="'indexxx_' + index" class="rating_scale-part_wrapper rest_part">
                                            <div class="rating_scale-part"></div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="organization.customer_rating" class="w-100 my-2">
                            <b-row>
                                <b-col>
                                    <p class="fs-14 fw-400 m-0 grey-color">
                                        Рейтинг заказчика:
                                        <span class="fw-600 grey-color"> {{ $formatPrice(organization.customer_rating) }} </span>
                                    </p>
                                </b-col>
                                <b-col md="auto">
                                    <div class="rating_scale float-right">
                                        <div v-for="(el, index) in organizationCustomerRatingWhole" :key="'index_' + index" :style="`border-color: ${customerRatingColor}`" class="rating_scale-part_wrapper">
                                            <div :style="`background-color: ${customerRatingColor}`" class="rating_scale-part"></div>
                                        </div>
                                        <div v-for="(el, index) in Math.ceil(organizationCustomerRatingRest)" :key="'indexx_' + index" class="rating_scale-part_wrapper">
                                            <div :style="`background: linear-gradient(to right, ${customerRatingColor} 0%, ${customerRatingColor} ${customerTransitionPercent}%, #fff ${customerTransitionPercent}%, #fff 100%)`" class="rating_scale-part"></div>
                                        </div>
                                        <div v-for="(el, index) in customerRest" :key="'indexxx_' + index" class="rating_scale-part_wrapper rest_part">
                                            <div class="rating_scale-part"></div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
                <b-col class="organization_part-body_col">
                    <div class="my-2">
                        <div v-if="organization.ogrn" class="my-2">
                            <p class="fs-14 fw-400 m-0 text-uppercase grey-color">
                                ОГРН / ОГРНИП: <span class="fw-600 grey-color"> {{ organization.ogrn }} </span>
                            </p>
                        </div>
                        <div v-if="organization.inn" class="my-2">
                            <p class="fs-14 fw-400 m-0 text-uppercase grey-color">
                                ИНН: <span class="fw-600 grey-color"> {{ organization.inn }} </span>
                            </p>
                        </div>
                        <div v-if="organization.kpp">
                            <p class="fs-14 fw-400 m-0 text-uppercase grey-color">
                                КПП: <span class="fw-600 grey-color"> {{ organization.kpp }} </span>
                            </p>
                        </div>
                    </div>
                </b-col>
            </div>
        </div>
    </b-col>
</template>

<script>
export default {
    name: 'organization-list-card',
    props: ['organization'],
    methods: {},
    computed: {
        ratingColor() {
            if (this.organization.rating <= 2) {
                return '#E75D4F';
            } else if (this.organization.rating > 2 && this.organization.rating < 4) {
                return '#F6B33A';
            } else {
                return '#26B89A';
            }
        },
        customerRatingColor() {
            if (this.organization.customer_rating <= 2) {
                return '#E75D4F';
            } else if (this.organization.customer_rating > 2 && this.organization.customer_rating < 4) {
                return '#F6B33A';
            } else {
                return '#26B89A';
            }
        },
        organizationRatingWhole() {
            return Math.floor(this.organization.rating);
        },
        organizationCustomerRatingWhole() {
            return Math.floor(this.organization.customer_rating);
        },
        organizationRatingRest() {
            return this.organization.rating - this.organizationRatingWhole;
        },
        organizationCustomerRatingRest() {
            return this.organization.customer_rating - this.organizationCustomerRatingWhole;
        },
        rest() {
            return 5 - Math.ceil(this.organization.rating);
        },
        customerRest() {
            return 5 - Math.ceil(this.organization.customer_rating);
        },
        transitionPercent() {
            return this.organizationRatingRest * 100;
        },
        customerTransitionPercent() {
            return this.organizationCustomerRatingRest * 100;
        }
    }
};
</script>

<style scoped>
.lable {
    font-size: 12px;
    font-weight: 600;
    background: #fff;
    border-radius: 4px;
    color: var(--green-color);
    padding: 1px 11px;
    margin-left: 11px;
    line-height: 1;
    display: flex;
    align-items: center;
}

.rating_scale {
    border: 1px solid rgba(149, 155, 164, 0.25);
    border-radius: 4px;
    display: flex;
    flex-wrap: nowrap;
    width: max-content;
}

.rating_scale-part {
    width: 9px;
    height: 14px;
    border-radius: 3px;
}

.rating_scale-part_wrapper {
    border-radius: 4px;
    border: 1px solid rgba(149, 155, 164, 0.25);
    margin: 1px;
}

.max-content {
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
}

.visible-768 {
    display: none;
}

.purchase_part {
    box-shadow: 0px 2px 4px #0000000a;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    background-color: #fff;
}

.organization_part-header {
    -webkit-border-radius: 4px 4px 0 0;
    -moz-border-radius: 4px 4px 0 0;
    border-radius: 4px 4px 0 0;
    background-color: var(--orange-color);
    padding: 9px 11px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-height: 40px;
}

.organization_part-body {
    padding: 5px 15px;
}

.organization_part-header_number {
    font-size: 12px;
    color: #fff;
    margin: 0;
}

.organization_part-header_label {
    text-transform: uppercase;
    color: #fff;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 12px;
}

.organization_part-body_col + .organization_part-body_col::before {
    content: '';
    width: 1px;
    height: 100%;
    position: absolute;
    background-color: #d9d9de;
    left: 0px;
}

.organization_part-body span {
    text-transform: none;
}

@media screen and (max-width: 767px) {
    .organization_part-body {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .organization_part-body_col::before {
        display: none;
    }
}

@media screen and (max-width: 992px) {
    .visible-768 {
        display: block;
    }
}

@media screen and (max-width: 568px) {
    .organization_part-header {
        -webkit-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    .organization_part-header_number {
        margin: 15px 0;
    }
}
</style>
